import { Component, OnDestroy, OnInit } from '@angular/core';
// import { productosPath } from '../../helpers/constants';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IRoute } from './../../Entities/entities';
import { EventsService } from './../../services/events.service';

@Component({
  selector: 'app-site-map-navigator',
  templateUrl: './site-map-navigator.component.html',
  styleUrls: ['./site-map-navigator.component.sass'],
})
export class SiteMapNavigatorComponent implements OnInit, OnDestroy {
  navigationTree: IRoute[];
  routeChangeSubscription: Subscription;
  constructor(
    eventSrv: EventsService,
    private router: Router,
    private eventService: EventsService
  ) {
    this.routeChangeSubscription = eventSrv.routeChange$.subscribe(
      (routeTree: IRoute[]) => {
        this.navigationTree = routeTree
          .filter(x => x.label)
          .filter(
            (x, index, array) =>
              !(x.label === 'Resumen' && index === array.length - 2)
          );
      }
    );
  }

  navigateTo(route: IRoute) {
    /* this.router.navigate([route.path + '/' + route.rootPath]); */
    if (route.rootPath && !route.path) {
      this.router.navigate([route.rootPath]);
    } else if (route.path) {
      this.router.navigate([route.rootPath + '/' + route.path]);
    } else if (route.tabIndexes) {
      this.eventService.setTabIndex(route.tabIndexes);
    }
  }

  /* getChildRouteByName(item: IRoute, path: string): string {
    if (path in item.children) {
      return item.children[path].label;
    } else {
      return '';
    }
  } */

  ngOnDestroy(): void {
    this.routeChangeSubscription.unsubscribe();
  }

  ngOnInit() {}
}
